import { render } from "./inReviewEvaluation.vue?vue&type=template&id=940bd692"
import script from "./inReviewEvaluation.vue?vue&type=script&lang=js"
export * from "./inReviewEvaluation.vue?vue&type=script&lang=js"

import "./inReviewEvaluation.vue?vue&type=style&index=0&id=940bd692&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__